export default /**
 * Get 'The value should be between limit.from and limit?.to' text
 * @param limit
 * @returns {`The value should be between ${*} and ${*}`}
 */
function getRestrictionText(limit) {
    return `The value should be between ${limit?.from} and ${limit?.to}`
}